<div class="consent-container">
  <rs-web-whitelabel-image
    [whitelabelImage]="WhitelabelImage.POINTING"
    [altTag]="WhitelabelImageAltTag.POINTING | translate"
    [whitelabelImageType]="WhitelabelImageType.SVG"
    [onSurface]="true"
  ></rs-web-whitelabel-image>
  <h1>{{ 'consent.data_policy_title' | translate }}</h1>

  <p>
    {{ 'consent.data_policy_start' | translate }}
    <a
      [routerLink]="privacyFooterItem.unauthenticatedBase"
      [queryParams]="{ link: privacyFooterItem.link }"
    >
      {{ 'consent.data_policy_link' | translate }}
    </a>
    {{ 'consent.data_policy_end' | translate }}
  </p>

  <div class="d-flex flex-column gap-2 action-buttons">
    <button
      im-button
      class="primary"
      (click)="acceptConsent.emit({ legalTextId: legalTexts().privacyId, consentGiven: true })"
      [disabled]="isLoading()"
    >
      {{ 'next' | translate }}
    </button>
  </div>
</div>
